import { getFontSize } from '../../../../../constants/fontSizes';

export const selectInfoSectionStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    backgroundColor: '#FFFFFF',
    borderRadius: '90px',
    padding: '15px 24px 15px 24px',
    marginTop: '65px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    width: "60vw",
  },
  searchButton: {
    borderRadius: '90px',
    padding: '12px 50px',
    height: 'auto',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    fontSize: getFontSize(18),
    fontWeight: 600,
    fontFamily: 'Lato',
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
};

